import {gaConfig} from '@stencil/hotels-config';
import {pushga} from '@stencil/ga-utils';
import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {
  isAltAccoSelector,
  propertyLabelSelector,
  searchHotelDetailsSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';
import {AppState} from '../../../verticals/hotels-dweb/src/shared/store';

const {detailsPageClickEventCategoryName} = gaConfig;

const detailsPagePushGaThunk = ({
  event,
  eventCategory = detailsPageClickEventCategoryName,
  eventAction,
  eventLabel,
  customDimensions,
}: {
  event?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: any;
  customDimensions?: Object;
}): ThunkAction<void, AppState, {}, AnyAction> => {
  return (_: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const storeState = getState();

    // @Note
    // This never type shall be fixed with global type fix redux and typescript Version bump to 4 above
    const {hotelId} = searchHotelDetailsSelector(storeState as never) || {};
    const propertyType = propertyLabelSelector(storeState as never);
    const isAltAcco = isAltAccoSelector(storeState as never);

    const defaultCds = {
      ...customDimensions,
      cdHotelVoy: hotelId,
      propertyType: propertyType,
    };

    if (isAltAcco !== undefined) {
      Object.assign(defaultCds, {cdaltacc: isAltAcco});
    }

    const gaPushKeys = {
      event,
      eventCategory,
      eventAction,
      eventLabel,
      ...defaultCds,
    };

    pushga(gaPushKeys);
  };
};

export default detailsPagePushGaThunk;
